import { Button, Typography, Stack, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import useLocales from '#/hooks/useLocales';
import Iconify from '#/components/shared/ui/Iconify';

interface UpgradePromptButtonProps {
  fullWidth?: boolean;
  size?: 'small' | 'medium' | 'large';
  sx?: object;
}

const UpgradePromptButton = ({
  fullWidth = false,
  size = 'medium',
  sx = {},
}: UpgradePromptButtonProps) => {
  const { translate } = useLocales();

  return (
    <Box sx={{ textAlign: 'center', ...sx }}>
      <Stack spacing={1} alignItems="center">
        <Typography variant="body2" color="text.secondary" textAlign="center">
          {String(translate('global.needSubscription'))}
        </Typography>
        <Button
          component={RouterLink}
          to="/dashboard/user/account?billing=true"
          variant="contained"
          color="primary"
          size={size}
          fullWidth={fullWidth}
          startIcon={<Iconify icon="eva:arrow-upward-fill" />}
          sx={{ mt: 1 }}
        >
          <Typography variant={size === 'small' ? 'body2' : 'body1'}>
            {String(translate('global.upgradePlan'))}
          </Typography>
        </Button>
      </Stack>
    </Box>
  );
};

export default UpgradePromptButton;
